﻿import { DataRequest } from 'shared/data/datarequest';

export class RuleDataRequest extends DataRequest {
    identifier: string;
    ruleName: string;

    constructor(identifier: string, ruleName: string) {
        super();

        this.$type = 'Web.RuleDataRequest';
        this.identifier = identifier;
        this.ruleName = ruleName;
    }
}